import { render } from "./signaturePad.vue?vue&type=template&id=52ecbf4b"
import script from "./signaturePad.vue?vue&type=script&lang=js"
export * from "./signaturePad.vue?vue&type=script&lang=js"

import "./signaturePad.vue?vue&type=style&index=0&id=52ecbf4b&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "52ecbf4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52ecbf4b', script)) {
    api.reload('52ecbf4b', script)
  }
  
  module.hot.accept("./signaturePad.vue?vue&type=template&id=52ecbf4b", () => {
    api.rerender('52ecbf4b', render)
  })

}

script.__file = "src/components/signaturePad.vue"

export default script